<template>
  <div class="main container">
    <h2>Passes</h2>
    <div class="line"></div>

    <loader :isLoading = "requestInProgress"/>

    <!-- Create Pass -->
    <div v-if="accountType === 'business'" class="create-section">
      <button type="button" class="btn create-btn d-flex flex-row" @click="goToCreatePass()">
        <img src="@/assets/img/icon-add.png">
        <div class="create-btn-title">New Pass</div>
      </button>
    </div>
    <!-- End Create Pass -->
    <div>
      <!-- ACTIVE PASSES HERE-->
      <pass-list-view
        status="Active"
        :accountType="accountType"
        :passData="activePasses"
        :convertUnixToDateTimeFormat="convertUnixToDateTimeFormat"/>

      <!-- PENDING PASSES HERE-->
      <pass-list-view
        status="Pending"
        :accountType="accountType"
        :passData="pendingPasses"
        :convertUnixToDateTimeFormat="convertUnixToDateTimeFormat"/>

      <!-- REJECTED PASSES HERE-->
      <pass-list-view
        status="Inactive"
        :accountType="accountType"
        :passData="inactivePasses"
        :convertUnixToDateTimeFormat="convertUnixToDateTimeFormat"/>
    </div>

    <div v-if="error_message">{{ error_message }}</div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import PassListView from '@/components/listview/PassListView'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'
import { DateTimeHelper } from '@/api/helper/DateTimeHelper'

const api = new APIService()
const auth = new AuthService()
const dateHelper = new DateTimeHelper()

export default {
  components: {
    Loader,
    PassListView
  },
  data() {
    return {
      requestInProgress: false,
      username: '',
      userId: auth.getUserId(),
      accountType: auth.getAccountType(),
      passes: [],
      activePasses: [],
      pendingPasses: [],
      inactivePasses: [],
      activePassText: 'Active Pass',
      inactivePassText: 'Inactive Pass',
      error_message: ''
    }
  },
  mounted() {
    this.requestInProgress = true
    this.accountType = auth.getAccountType()
    if (this.accountType === 'business') this.getBusinessPasses()
    else this.getIndividualPasses()
  },
  methods: {
    async getBusinessPasses() {
      try {
        this.requestInProgress = true
        const passData = await api.getBusinessPasses(this.userId)
        this.passes = passData
        if(this.passes.length !== 0) {
          this.passes.sort((a, b) => a.date_created - b.date_created)
          this.filterBusinessPasses()
        }
        this.requestInProgress = false
      } catch(e) {
        console.log('e: ', e)
        // this.redirectToLogin()
      }
    },
    async getIndividualPasses() {
      try {
        this.requestInProgress = true
        const passData = await api.getIndividualPasses(this.userId)
        this.passes = passData
        console.log('this.passes: ', this.passes)
        if(this.passes.length !== 0) {
          this.passes.sort((a, b) => a.pass_details.valid_from - b.pass_details.valid_from)
          this.filterIndividualPasses()
        }
        this.requestInProgress = false
      } catch(e) {
        console.log('e: ', e)
        // this.redirectToLogin()
      }
    },
    filterBusinessPasses() {
      // check expired and deactivated passes
      this.passes.map(d => {
        if(d.status === 'Active') this.activePasses.push(d)
        else if(d.status === 'Pending') this.pendingPasses.push(d)
        else this.inactivePasses.push(d)
      })
    },
    filterIndividualPasses() {
      this.passes.map(d => {
        if(d.pass_status === 'Active') this.activePasses.push(d)
        else if(d.pass_status === 'Pending' || d.pass_status === 'Waiting for approval')
          this.pendingPasses.push(d)
        else this.inactivePasses.push(d)
      })
    },
    convertUnixToDateTimeFormat(date) {
      return dateHelper.convertUnixToDateTimeFormat(date)
    },
    redirectToLogin() {
      auth.logout()
      this.$router.push('/login')
    },
    goToCreatePass() {
      this.$router.push('/create-pass')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.create-btn {
  padding: 0px;
  align-items: center;
}
.create-btn img {
  width: 24px;
  margin-bottom: 0px;
}

.fas {
  border-radius: 50%;
  border: solid 1px #0091f4;
}
.create-btn-title {
  margin-left: 12px;
  font-size: 24px;
  font-family: 'HKGrotesk-Bold', Helvetica, sans-serif;
  color: #0091f4;
}
.create-section {
  padding-left: 0;
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/Passes.vue